import { Component,EventEmitter,Output, ViewChild, Input } from '@angular/core';
import {Content} from 'ionic-angular';
/**
 * Generated class for the AlphascrollComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'alphascroll',
  templateUrl: 'alphascroll.html'
})
export class AlphascrollComponent {
  @ViewChild(Content) content: Content;

  @Input() items: any;
  @Output() letterChoose = new EventEmitter()

  constructor() {

  }

  hover(letter:string) {
      this.letterChoose.emit({name:letter})
  }

}



// WEBPACK FOOTER //
// ./src/components/alphascroll/alphascroll.ts